
define('text!templates/modules/template/edit/form/template-form.html',[],function () { return '<div class="name-input"></div>\n<div class="share-input"></div>\n';});

